<template>
	<div id="security-alert-dialog">
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';

	export default defineComponent({});
</script>
